/**
 * Skeleton loading global untuk semua halaman.
 * Ditampilkan saat config belum selesai di-load (header + content + footer).
 * Dipakai di ConfigLoader agar setiap halaman (contact, shop, collection, dll) tampil konsisten.
 */
export default function PageSkeleton() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header skeleton */}
      <header className="sticky top-0 z-40 border-b border-nevada-100 bg-white">
        <div className="mx-auto flex h-14 md:h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="h-8 w-24 md:w-32 bg-nevada-200 animate-pulse rounded" />
          <div className="hidden md:flex items-center gap-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="h-4 w-16 bg-nevada-200 animate-pulse rounded"
              />
            ))}
          </div>
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 bg-nevada-200 animate-pulse rounded-full" />
            <div className="h-9 w-9 bg-nevada-200 animate-pulse rounded-full" />
          </div>
        </div>
      </header>

      {/* Main content skeleton - generic untuk semua halaman */}
      <div className="overflow-x-hidden pt-0 pb-0 md:pt-2">
        {/* Hero / page title area */}
        <section className="w-full px-4 sm:px-6 md:px-12 lg:px-16 py-8 md:py-12">
          <div className="mx-auto max-w-3xl text-center space-y-4">
            <div className="h-9 md:h-10 w-64 md:w-80 bg-nevada-200 animate-pulse rounded mx-auto" />
            <div className="h-4 w-full max-w-xl bg-nevada-100 animate-pulse rounded mx-auto" />
            <div className="h-4 w-3/4 max-w-md bg-nevada-100 animate-pulse rounded mx-auto" />
          </div>
        </section>

        {/* Content blocks (cards/rows) */}
        <section className="px-4 sm:px-6 md:px-12 lg:px-16 pb-12">
          <div className="mx-auto max-w-5xl space-y-6">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="rounded-2xl border border-nevada-100 bg-nevada-50/50 p-6 md:p-8 animate-pulse"
              >
                <div className="flex flex-col md:flex-row gap-4 md:gap-6">
                  <div className="h-12 w-12 bg-nevada-200 rounded-full flex-shrink-0" />
                  <div className="flex-1 space-y-3">
                    <div className="h-5 w-32 bg-nevada-200 rounded" />
                    <div className="h-4 w-full max-w-md bg-nevada-200 rounded" />
                    <div className="h-4 w-2/3 bg-nevada-100 rounded" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Footer skeleton */}
        <footer className="border-t border-nevada-200 bg-nevada-50 mt-12">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="space-y-3">
                  <div className="h-4 w-24 bg-nevada-200 animate-pulse rounded" />
                  <div className="h-3 w-32 bg-nevada-100 animate-pulse rounded" />
                  <div className="h-3 w-28 bg-nevada-100 animate-pulse rounded" />
                  <div className="h-3 w-36 bg-nevada-100 animate-pulse rounded" />
                </div>
              ))}
            </div>
            <div className="pt-6 border-t border-nevada-200 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="h-5 w-32 bg-nevada-200 animate-pulse rounded" />
              <div className="flex gap-4">
                <div className="h-5 w-16 bg-nevada-200 animate-pulse rounded" />
                <div className="h-5 w-16 bg-nevada-200 animate-pulse rounded" />
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
